import { Guid } from '@web/utils';
import { AdminBoxSaleGroupCosmetic } from './admin-box-sale-group-cosmetic';

export class AdminBoxSaleVariant {
  public constructor(
    private readonly data: {
      cosmetics: AdminBoxSaleGroupCosmetic[];
      id: Guid;
      name: string;
    },
  ) {}

  public get cosmetics(): AdminBoxSaleGroupCosmetic[] {
    return this.data.cosmetics;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }
}
